import {
  Box,
  Typography,
  useTheme,
} from '@mui/material';

interface AvatarProps {
  label: string;
  color: string;
}

export function Avatar({ label, color }: AvatarProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: theme.spacing(4),
        height: theme.spacing(4),
        borderRadius: theme.spacing(2),
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color,
      }}
    >
      <Typography
        variant="bodyMdProminent"
        sx={{
          color: theme.palette.common.white,
          fontWeight: 700,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
